import { createReducer, on } from '@ngrx/store';
import {
  ActiveComponentChanged,
  ResetStateFromRouter,
} from 'src/app/shared/actions/eliqua.actions';
import { DateChanged, UpdateDateSuccess } from '../actions/date.actions';
import { CloseCEUpdateDateDialog, OpenCEUpdateDateDialog } from '../actions/search.actions';
import { DateState } from '../models/campaign-management.model';

export const initialState: DateState = {
  dateFormat: '',
  date: new Date(0),
  column: '',
};

export const DateReducer = createReducer(
  initialState,
  on(OpenCEUpdateDateDialog, (state, { row, columnVal }) => ({
    ...state,
    dateFormat: String(row[columnVal as keyof typeof row]),
    date: new Date(row[columnVal as keyof typeof row] as string | number | Date),
    column: columnVal,
  })),
  on(DateChanged, (state, { dateFormat, date }) => ({
    ...state,
    dateFormat,
    date,
  })),
  on(ActiveComponentChanged, CloseCEUpdateDateDialog, UpdateDateSuccess, () => initialState),
  on(ResetStateFromRouter, () => ({
    ...initialState,
  })),
);
